// src/components/TopNav.js
import React from "react";
import { Link } from "react-router-dom";   // ✅ NEW!
import "../styles/TopNav.css";
import logo from "../assets/navbar_logo.png";

const TopNav = () => {
  return (
    <nav className="top-nav">
      <div className="logo">
        <Link to="/library">
          <img src={logo} alt="Libris Logo" className="logo-image" />
        </Link>
      </div>

      <ul className="nav-links">
        <li>
          <Link to="/library">Home</Link>
        </li>
        <li>My List</li>
        <li>Quizzes</li>
        <li>
          <Link to="/Roadmap">Roadmap</Link>
        </li>  
      </ul>

      <div className="account-info">
        <button className="login-button">Log In</button>
      </div>
    </nav>
  );
};

export default TopNav;
